module.exports = {
    "--av-nav-primary": "rgba(45, 49, 56, 1)",
    "--av-nav-secondary": "rgba(113, 121, 134, 1)",
    "--av-nav-text": "rgba(255, 255, 255, 1)",
    "--av-nav-text-active": "rgba(255, 255, 255, 1)",
    "--av-scroll-thumb": "rgba(36, 49, 67, 0.40)",
    "--av-scroll-thumb-inverse": "rgba(255, 255, 255, 0.40)",
    "--av-brand-primary": "rgba(68, 81, 94, 1)",
    "--av-brand-light": "rgba(68, 81, 94, 0.30)",
    "--av-brand-accent": "rgba(68, 81, 94, 0.10)",
    "--av-brand-lightest": "rgba(68, 81, 94, 0.05)",
    "--av-solid-brand-accent": "rgba(239, 240, 242, 1)",
    "--av-solid-brand-lightest": "rgba(247, 248, 249, 1)",
    "--av-gradient-to-bottom-brand-lightest": "linear-gradient(rgba(38, 104, 197, 0.05), rgba(38, 104, 197, 0.00))",
    "--av-gradient-to-top-brand-lightest": "linear-gradient(rgba(38, 104, 197, 0.00), rgba(38, 104, 197, 0.05))",
    "--av-gradient-nav-primary": "linear-gradient(rgba(25, 58, 131, 1.00), rgba(0, 32, 77, 1.00))",
    "--av-brand-secondary": "rgba(64, 139, 234, 1)",
    "--av-brand-secondary-light": "rgba(64, 139, 234, 0.30)",
    "--av-brand-secondary-accent": "rgba(64, 139, 234, 0.15)",
    "--av-fixed-primary": "rgba(36, 49, 67, 1)",
    "--av-fixed-secondary": "rgba(36, 49, 67, 0.90)",
    "--av-fixed-light": "rgba(36, 49, 67, 0.60)",
    "--av-fixed-lighter": "rgba(36, 49, 67, 0.40)",
    "--av-fixed-lightest": "rgba(36, 49, 67, 0.20)",
    "--av-fixed-invisible": "rgba(36, 49, 67, 0.10)",
    "--av-fixed-white": "rgba(255, 255, 255, 1)",
    "--av-fixed-white-secondary": "rgba(255, 255, 255, 0.95)",
    "--av-fixed-white-light": "rgba(255, 255, 255, 0.60)",
    "--av-fixed-white-lighter": "rgba(255, 255, 255, 0.40)",
    "--av-fixed-white-lightest": "rgba(255, 255, 255, 0.20)",
    "--av-fixed-white-invisible": "rgba(255, 255, 255, 0.10)",
    "--av-fixed-success-dark": "rgba(96, 148, 37, 1)",
    "--av-fixed-success-dark-accent": "rgba(96, 148, 37, 0.30)",
    "--av-fixed-success": "rgba(155, 194, 37, 1)",
    "--av-fixed-success-accent": "rgba(155, 194, 37, 0.15)",
    "--av-fixed-warning": "rgba(255, 163, 16, 1)",
    "--av-fixed-warning-accent": "rgba(255, 163, 16, 0.15)",
    "--av-fixed-critical": "rgba(255, 114, 0, 1)",
    "--av-fixed-critical-accent": "rgba(255, 114, 0, 0.15)",
    "--av-fixed-danger": "rgba(217, 44, 35, 1)",
    "--av-fixed-danger-accent": "rgba(217, 44, 35, 0.15)",
    "--av-solid-brand-secondary-light": "rgba(198, 220, 249, 1)",
    "--av-solid-brand-secondary-accent": "rgba(226, 238, 252, 1)",
    "--av-solid-fixed-invisible": "rgba(233, 234, 236, 1)",
    "--av-solid-fixed-success-accent": "rgba(240, 246, 222, 1)",
    "--av-solid-fixed-warning-accent": "rgba(255, 241, 219, 1)",
    "--av-solid-fixed-critical-accent": "rgba(255, 234, 217, 1)",
    "--av-solid-fixed-danger-accent": "rgba(249, 223, 222, 1)",
    "--av-fixed-link": "rgba(38, 104, 197, 1)",
    "--av-fixed-link-light": "rgba(190, 210, 238, 1)",
    "--av-fixed-info": "rgba(64, 139, 234, 1)",
    "--av-fixed-info-accent": "rgba(64, 139, 234, 0.15)",
    "--av-fixed-focus": "rgba(64, 139, 234, 0.30)",
    "--av-fixed-highlight": "rgba(255, 223, 0, 1)",
}
